<template>
  <div>
    <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">

      <div class="row">
        <RangeDatePicker
          id="selected-time-date-picker"
          v-model="filters.dateRange"
          class="col-12 col-md-4 datesFilter"
          :placeholder="$t('optometry.leads.date_range')">

        <div slot="label">
          <label class="form-label" style="margin-top: -3px;">
            {{ $t('statistics.daterange_start') }}
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'createdAt', 'selectedDateLabel': filters.date == 'createdAt'}" @click="setDate('createdAt')">{{ $t('statistics.daterange_created_at') }}</span>
            <span class="dateSeparatorLabel">/</span>
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'updatedAt', 'selectedDateLabel': filters.date == 'updatedAt'}" @click="setDate('updatedAt')">{{ $t('statistics.daterange_updated_at') }}</span>
            {{ $t('statistics.daterange_end') }}:
          </label>
        </div>
        </RangeDatePicker>

        <!-- Entities Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{$t('users.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entities"
            :options="authorizedEntities"
            track-by="id"
            :custom-label="formatedEntityLabel"
            label="name"
            select-label=''
            selected-label=''
            deselect-label="×"
            placeholder="---"
            :searchable="true"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false">
            <span slot="noResult">{{$t('optometry.leads.table.no_results')}}</span>
            <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>{{ option.name }}&nbsp;<span v-if="option.entities"> 📂</span></span>
                  <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                </span>
            </template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="filters.entities.length" @mousedown.prevent.stop="filters.entities = []"></div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <v-server-table
      id="wellbeingLeadsTable"
      ref="wellbeingLeadsTable"
      :name="'wellbeingLeadsTable'"
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleLeadClicked">

      <span slot="entity" slot-scope="props">
        {{ authorizedEntities ? authorizedEntities.some(entity => entity.id === parseInt(props.row.entityId)) ? authorizedEntities.find(entity => entity.id === parseInt(props.row.entityId)).name : "N/A" : "N/A"}}
      </span>

      <span slot="status" slot-scope="props">
        {{ getStatusById(props.row.status.id) }}
      </span>

      <span slot="updatedAt" class="no-break" slot-scope="props">{{ props.row.updatedAt | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>

    </v-server-table>
  </div>

</template>

<script>
import RangeDatePicker from '@/components/common/RangeDatePicker'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import Multiselect from 'vue-multiselect'
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    RangeDatePicker,
    Multiselect,
  },
  mixins: [
    IsFromEvolluMixin,
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
        entities: [],
        date: 'createdAt',
        dateRange: {
          start: null,
          end: null
        }
      },
      numberVisibleLeads: 0,
      showTags: false,
      queryUrl: `${this.$store.state.wellbeing_server}/v1/leads`,
      columns: ['createdAt', 'updatedAt', 'name', 'surname', 'addressCity', 'entity', 'status'],
      tableOptions: {
        orderBy: {
          column: 'createdAt',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['createdAt', 'updatedAt'],
        sortable: ['createdAt', 'updatedAt'],
        customFilters: ['entities', 'start', 'end', 'date'],
        headings: {
          createdAt: this.$t('leads.table.created_at'),
          updatedAt: this.$t('leads.table.updated_at'),
          name: this.$t('wellbeing.leads.table.first_name'),
          surname: this.$t('wellbeing.leads.table.last_name'),
          addressCity: this.$t('leads.table.address_city'),
          entity: this.$t('leads.table.entity'),
          status: this.$t('leads.table.status'),
        },
        columnsClasses: {
          createdAt: 'createdAt',
          updatedAt: 'updatedAt',
          city: 'city',
          entity: 'entity'
        },
      }

    }
  },
  created: function () {
    this.checkActiveFilters()
  },
  methods: {
    getStatusById: function (id) {
      let status = this.statuses.find(status => status.id === parseInt(id))
      return status ? this.$t(status.name) : null
    },
    handleLeadClicked: function ({ row }) {
      let selectedLead = row
      selectedLead.entity = this.authorizedEntities ? this.authorizedEntities.some(entity => entity.id === parseInt(row.entityId)) ? this.authorizedEntities.find(entity => entity.id === parseInt(row.entityId)) : null : null
      this.$emit('leadClicked', selectedLead)
    },
    reload: function () {
      this.$refs.wellbeingLeadsTable.refresh()
    },
    onLoading: function () {
      this.$emit('loading')
    },
    onLoaded: function (state) {
      this.$emit('loaded', state)
    },
    setDate: function (date) {
      this.filters.date = date
    },
    checkActiveFilters: function () {
      return new Promise((resolve) => {
        this.$emit('filters-updated', this.activeFilters)
        if (this.activeFilters > 0) {
          this.$emit('update:showFilters', true)
        }
        resolve()
      })
    },
  },
  computed: {
    ...mapGetters({
      statuses: 'wellbeing/statuses',
    }),
    activeFilters: function () {
      let count = 0
      if (this.filters.entities.length > 0) count++
      if (this.filters.dateRange.start || this.filters.dateRange.end) count++
      return count
    },
    authorizedEntities: function () {
      let wellbeingService = this.$store.state.services.find(service => service.url === this.$store.state.wellbeing_server) || null
      if (wellbeingService) {
        if (wellbeingService.user_permissions.some(p => p.entity_id === null)) {
          return wellbeingService.entities
        } else {
          return wellbeingService.entities.filter(entity => wellbeingService.user_permissions.filter(p => p.entity_id === entity.id))
        }
      }
      return null
    },
  },
  watch: {
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    customQueries: {
      handler: function (value) {
        if (value.entities && value.entities !== '') {
          this.filters.entities = this.authorizedEntities.filter(ent => value.entities.split(',').some(elem => parseInt(elem) === ent.id))
        }
        if (value.date && value.date !== '') {
          this.filters.date = value.date
        }
        if (value.start && value.start !== '') {
          this.filters.dateRange.start = value.start
        }
        if (value.end && value.end !== '') {
          this.filters.dateRange.end = value.end
        }
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs.wellbeingLeadsTable.setFilter(value)
    },
    'filters.dateRange': function (value) {
      this.$refs.wellbeingLeadsTable.customQueries.start = value.start || ''
      this.emitTableFilter('vue-tables.wellbeingLeadsTable.filter::end', value.end || '')
    },
    'filters.date': function (date) {
      if (date === '') {
        this.$refs.wellbeingLeadsTable.customQueries.date = date
      } else {
        this.emitTableFilter('vue-tables.wellbeingLeadsTable.filter::date', date)
      }
    },
    'filters.entities': function (options) {
      const optionsIds = options.map(option => option.id).join(',')
      this.emitTableFilter('vue-tables.wellbeingLeadsTable.filter::entities', optionsIds)
    },
    activeFilters: function (nrFilters) {
      this.$emit('filters-updated', nrFilters)
    }
  }
}
</script>

<style lang="scss">

.unselectedDateLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: line-through !important;
}

.dateSeparatorLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.selectedDateLabel {
  font-size: 0.6rem !important;
  color: #29c4a9 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

</style>
